import { atom } from "recoil";

export const searchContestState = atom<{ value: string }>({
  key: "searchContestState",
  default: {
    value: ""
  }
});

export const filterContestTab = atom<{ value: string }>({
  key: "filterContestTab",
  default: {
    value: "all"
  }
});
